import styled from 'styled-components';

export const ImageDropZoneContainer = styled.div<{ $isInForm?: boolean }>`
  padding: 1rem;
  display: flex;
  justify-content: ${({ $isInForm }) => ($isInForm ? '' : 'center')};
  align-items: center;
`;

export const ModalImageContainer = styled.div`
  display: block;
`;

export const SaveButton = styled.div`
  margin-left: 10px;
`;

export const ImageCropperButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 4rem;
  margin-right: 4rem;
  padding-bottom: 1.5rem;
`;

export const ModalImage = styled.div`
  margin: 3rem 3rem 1rem 3rem;
  text-align: center;
  background-color: lightgrey;
  line-height: 0;
`;

export const DropZoneTitle = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a6};
  align-items: center;
  &:focus {
    outline: none;
  }
`;

export const DropZoneText = styled.span`
  margin-left: 0.5rem;
`;

export const ErrorMessage = styled.span`
  color: rgb(255, 76, 121);
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  text-align: center;
`;
